import { agentConstants } from '../_constants/agent.constant';

const initialState = {
    loading: false,
    data: null, // This will hold { statusOptions, reasonOptions }
    error: null
};

export function agentOptions(state = initialState, action: any) {
    switch (action.type) {
        case agentConstants.GET_AGENT_OPTIONS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case agentConstants.GET_AGENT_OPTIONS_SUCCESS:
            return {
                loading: false,
                data: action.data,
                error: null
            };
        case agentConstants.GET_AGENT_OPTIONS_FAILURE:
            return {
                loading: false,
                data: null,
                error: action.error
            };
        default:
            return state;
    }
}
